import React, { useState, useEffect } from "react";
import { Form, Button, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { register } from "../actions/userActions";
import Loader from "../components/Loader";
import Message from "../components/Message";
import FormContainer from "../components/FormContainer";
import Navbar from "../components/Navbar";
import "../App.css";
import { Multiselect } from "multiselect-react-dropdown";
import { listProducts } from "../actions/productActions";

const RegisterScreen = ({ location, history }) => {
  const [username, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [address, setAddress] = useState("");
  const [contact, setContact] = useState();
  const [isAdmin, setIsAdmin] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [role, setRole] = useState(null)
  const [genSetAssigned, setGenSetAssigned] = useState([])
  const dispatch = useDispatch();
  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;
  const userRegister = useSelector((state) => state.userRegister);
  const { loading, error, success } = userRegister;
  const redirect = location.search
    ? location.search.split("=")[1]
    : "/admin/userlist";
  const productList = useSelector((state) => state.productList);

  useEffect(() => {
    dispatch(listProducts());
    if (success) {
      history.push(redirect);
    }
  }, [history, success]);

  const submitHandler = (e) => {
    e.preventDefault();
    if (password !== confirmPassword) {
      setMessage("Password do not match");
    } else {
      const userData = {
        username,
        email,
        password,
        contact,
        address,
        isAdmin,
        role,
        assignedGensets: genSetAssigned
      };
      dispatch(register(userData));
    }
  };
  console.log(role)

  return (
    <>
      <Navbar />
      {/* <div className="tw-mx-8"> */}
      <br />
      <br />
      <br />
      <br />
      <div className="tw-w-5/6 md:tw-w-1/2 tw-my-8 tw-mx-auto tw-flex tw-justify-center tw-items-center tw-p-1 tw-border-1 tw-rounded-lg tw-shadow-2xl">
        <FormContainer>
          <h3 className="tw-font-nunito sm:tw-text-3xl tw-text-2xl tw-font-bold tw-text-center tw-mt-12">
            Create User
          </h3>
          {message && <Message variant="danger">{message}</Message>}
          {error && <Message variant="danger">{error}</Message>}
          {success && (
            <Message variant="success">User Registered Successfully!</Message>
          )}
          {loading && <Loader />}
          <Form onSubmit={submitHandler} className="tw-font-nunito">
            <Form.Group className="tw-py-2" controlId="username">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="username"
                placeholder="Enter Name"
                value={username}
                onChange={(e) => setUserName(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="email">
              <Form.Label>Email Address</Form.Label>
              <Form.Control
                type="email"
                placeholder="Enter email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Enter password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="confirmPassword">
              <Form.Label>Confirm Password</Form.Label>
              <Form.Control
                type="password"
                placeholder="Confirm password"
                value={confirmPassword}
                onChange={(e) => setConfirmPassword(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="username">
              <Form.Label>Contact</Form.Label>
              <Form.Control
                type="contact"
                placeholder="Enter Contact"
                value={contact}
                onChange={(e) => setContact(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="username">
              <Form.Label>Address</Form.Label>
              <Form.Control
                type="text"
                placeholder="Enter Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              ></Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="role">
              <Form.Label>Assigned Role</Form.Label>
              <Form.Control
                as="select"
                value={role}
                onChange={(e) => {
                  setRole(e.target.value)
                }}
              >
                <option value={null} >Select</option>
                {userInfo.role === "LOCAL_ADMIN" && <option value="USER">User</option>}
                {userInfo.role === "MAIN_ADMIN" && <option value="LOCAL_ADMIN">Local Admin</option>}
                {userInfo.role === "MAIN_ADMIN" && <option value="MAIN_ADMIN">Main Admin</option>}
              </Form.Control>
            </Form.Group>
            <Form.Group className="tw-py-2" controlId="role">
              <Multiselect
                style={{backgroundColor: "#fff"}}
                selectedValues={genSetAssigned}
                options={productList.products.map(e => ({key: `${e.gensetNumber}`, value: e._id}))}
                displayValue="key"
                onSelect={(e) => setGenSetAssigned(e)}
              />
            </Form.Group>
            <Button
              type="submit"
              className="tw-mb-8 tw-px-16 tw-block tw-mx-auto tw-transition tw-duration-700 tw-ease-in-out tw-transform hover:-tw-translate-y-1 hover:tw-scale-110 focus:tw-outline-none myButton"
            >
              Create
            </Button>
          </Form>
        </FormContainer>
      </div>
    </>
  );
};

export default RegisterScreen;
